import React from 'react';

const VideoStatistics = ({ bucketStats }) => {
    return (
        <div className="bg-white border border-[#6D9773]/20 rounded-lg shadow-sm p-6 text-[#0C3B2E] h-full">
            <h3 className="text-lg font-medium text-[#6D9773] mb-4">Video Statistics</h3>
            <div className="space-y-4">
                <div>
                    <p className="text-sm font-medium text-gray-600">All Time</p>
                    <p className="text-2xl font-semibold">{bucketStats?.allTime?.totalVideos || 0}</p>
                    <p className="text-xs text-gray-500">Total videos created</p>
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-600">Last 30 Days</p>
                    <p className="text-xl font-semibold">{bucketStats?.last30Days?.totalVideos || 0}</p>
                    <p className="text-xs text-gray-500">Recent videos</p>
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-600">Current Status</p>
                    <p className="text-xl font-semibold">{bucketStats?.pendingVideos || 0}</p>
                    <p className="text-xs text-gray-500">Videos in processing</p>
                </div>
            </div>
        </div>
    );
};

export default VideoStatistics;